import BaseProxyAcquisition from "@/proxies/base-proxy-acquisition";
/**
 * @class SendTwoFactorAuthenticationCodeProxy
 * @description Class used for sending otp code for user
 * @author Edmark Santos
 * @version 1.0
 * @since May 11, 2020
 */
export default class SendTwoFactorAuthenticationCodeProxy {
  /**
   * @async
   * @function sendTwoFactorAuthCode
   * @param input - Input parameter instance.
   * @param {String} input - input values to send
   */
  async sendTwoFactorAuthCode(input = {}) {
    let baseProxy = new BaseProxyAcquisition();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/two-factor-auth/${input.userId}/send-otp`;

    return await baseProxy.postData(endpointUrl, input);
  }

  async validateTwoFactorAuthCode(input = {}) {
    let baseProxy = new BaseProxyAcquisition();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/two-factor-auth/${input.userId}/validate-otp`;
    return await baseProxy.postData(endpointUrl, input);
  }

  async validateOnboardingTwoFactorAuthCode(input = {}) {
    let baseProxy = new BaseProxyAcquisition();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/two-factor-auth/${input.userId}/onboarding-validate-otp`;
    return await baseProxy.postData(endpointUrl, input);
  }
}
